import { EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';

@Injectable()
export class ReportsEventService {
    public search: EventEmitter<any> = new EventEmitter<any>();

    public selectedType: ReportType = ReportType.Enrollment;

    constructor() {}

    public onSearch(useV2: boolean = false) {
        this.search.emit(useV2);
    }

    public onTypeChange(type: ReportType) {
        this.selectedType = type;
    }
}

export enum ReportType {
    Enrollment,
    Capacity,
    Transaction
}
